var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-cf",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    d: "M-52-.5h768v127H-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M-52 383.5h768V512H-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009a00",
    d: "M-52 255h768v128.5H-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-52 126.5h768V255H-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M268 0h128v512H268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M109.5 112.3 75.9 89.1l-33.4 23.4 11.6-39.2-32.5-24.6 40.7-1L75.7 8.8l13.5 38.6 40.8.8L97.6 73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf);
export default __webpack_public_path__ + "static/media/cf.8200815d4e5dbcc4bcbeb2ed0baadb41.svg";
export { ForwardRef as ReactComponent };